<template>
    <CardPage :section="5" :page="7" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great work! You get a sticker for learning about assertive, passive, and aggressive communication!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section5/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section5/complete', true);
            this.$store.set('section5/sticker@earned', true);
        }
    }
};
</script>
